module.exports = __webpack_public_path__ + "img/626.2c259046.jpg";